module.exports = __webpack_public_path__ + "media/handshake.bfdbe2c3.svg";